<template>
  <RevCardCarousel
    :desktop-card-width
    :heading-size="headingSize || undefined"
    :mobile-card-width
    :next-alternative-text="altText.next"
    :prev-alternative-text="altText.prev"
    :size
    :subtitle="subtitle || ''"
    :title="title || ''"
  >
    <ModularCard
      v-for="(card, index) of cards"
      :key="card.id"
      :background="card.background"
      :blockPosition
      :blockTitle="title"
      :card-position="index + 1"
      class="h-full"
      :link="card.link"
      :sections="card.sections"
      :size
      :technical-name="card.technicalName"
      :tracking
      :with-padding="cardsHavePadding"
    />

    <template v-if="ctaLink" #button>
      <RevButton
        :icon="IconArrowRight"
        :rel="ctaLink?.link?.rel"
        size="medium"
        :target="ctaLink?.link?.target"
        :to="ctaLink?.link?.href"
        variant="primary"
      >
        {{ ctaLink?.label }}
      </RevButton>
    </template>
  </RevCardCarousel>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { ModularCardsCollectionApiProps } from '@backmarket/http-api/src/api-specs-content/models/modular-card'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { IconArrowRight } from '@ds/icons/IconArrowRight'

import translations from '../../common/CMS.translations'
import type { BlockProps } from '../../models/content-block'

import ModularCard from './ModularCard.vue'

const props = withDefaults(
  defineProps<
    Omit<ModularCardsCollectionApiProps, 'layout' | 'desktopLayout'> &
      BlockProps
  >(),
  {
    cardsHavePadding: true,
  },
)

const i18n = useI18n()

const altText = {
  prev: i18n(translations.alternativePrevious),
  next: i18n(translations.alternativeNext),
}

const desktopCardWidth = computed(() => {
  if (props.size === 'extra-small') return 'narrow'

  return props.size === 'medium' ? 'wide' : 'standard'
})

const mobileCardWidth = computed(() => {
  if (props.size === 'extra-small') return 'narrow'

  return 'standard'
})
</script>
